/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAttachMoneyIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-attach-money"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12.03 21.5Q11.47 21.5 11.09 21.11Q10.7 20.73 10.7 20.18L10.7 19.2Q9.5 18.9 8.65 18.25Q7.8 17.6 7.28 16.43Q7.08 15.95 7.3 15.44Q7.53 14.93 8.07 14.72Q8.55 14.53 9.03 14.74Q9.5 14.95 9.8 15.45Q10.22 16.13 10.82 16.46Q11.43 16.8 12.3 16.8Q13.28 16.8 13.86 16.38Q14.45 15.95 14.45 15.15Q14.45 14.4 13.88 13.9Q13.3 13.4 11.65 12.9Q9.22 12.18 8.34 11.06Q7.45 9.95 7.45 8.6Q7.45 6.9 8.44 5.95Q9.43 5 10.7 4.7L10.7 3.83Q10.7 3.27 11.09 2.89Q11.47 2.5 12.03 2.5Q12.57 2.5 12.96 2.89Q13.35 3.27 13.35 3.83L13.35 4.7Q14.2 4.83 14.95 5.34Q15.7 5.85 16.2 6.6Q16.5 7.05 16.29 7.6Q16.07 8.15 15.5 8.4Q15.07 8.57 14.61 8.43Q14.15 8.28 13.72 7.83Q13.43 7.5 13.03 7.33Q12.63 7.15 12.05 7.15Q11.07 7.15 10.59 7.58Q10.1 8 10.1 8.5Q10.1 9.22 10.69 9.64Q11.28 10.05 13.4 10.7Q15.2 11.22 16.18 12.39Q17.15 13.55 17.1 15.1Q17.05 17.05 16.01 18.02Q14.97 19 13.35 19.3L13.35 20.18Q13.35 20.73 12.96 21.11Q12.57 21.5 12.03 21.5Z" fill={color} />
    </svg>
  );
}
